import { useState, useEffect, useCallback } from "react";
import { Form, notification } from "antd";
import dayjs from "dayjs";
import _ from "lodash";
import $axios from "../services/axios";
import axios from "axios";
import { moveToFirst, removeDiacritics, formatString } from "../helpers/utils";

export const useBookingLogic = ({ setLoading, setStep }) => {
  const [countries, setCountries] = useState([]);
  const [filterCountries, setFilterCountries] = useState([]);
  const [chooseAddStep, setChooseAddStep] = useState(1);
  const [hotels, setHotels] = useState([]);
  const [openChooseHotel, setOpenChooseHotel] = useState(false);
  const [hotelSelected, setHotelSelected] = useState(null);
  const [form] = Form.useForm();
  const [provinces, setProvinces] = useState([]);
  const [filterProvinces, setFilterProvinces] = useState([]);
  const [searched, setSearched] = useState(false);
  const [addPrice] = useState(0);
  const [openDrawerChooseAdd, setOpenDrawerChooseAdd] = useState(false);
  const [openDrawerChooseHotel, setOpenDrawerChooseHotel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermHotel, setSearchTermHotel] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize] = useState(10);
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [displayHotels, setDisplayHotels] = useState([]);
  const [valueCalendar, setValueCalendar] = useState(new Date());
  const [openCalendar, setOpenCalendar] = useState(false);
  const [typeCalendar, setTypeCalendar] = useState("");
  const [minDateCalendar, setMinDateCalendar] = useState(new Date());
  const [countryDetect, setCountryDetect] = useState("");
  const [provinceDetect, setProvinceDetect] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [filterHotel, setFilterHotel] = useState([
    { value: "", name: "Tất cả" },
  ]);
  const [filter, setFilter] = useState({
    address: "",
    country: "",
    star: 6,
  });
  const [hotelSearch, setHotelSearch] = useState("");
  const [totalHotelCount, setTotalHotelCount] = useState(0);
  const [currentHotelPage, setCurrentHotelPage] = useState(1);
  const [hotelBatchSize] = useState(50);
  const [hasMoreHotels, setHasMoreHotels] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [currentAvailPage, setCurrentAvailPage] = useState(1);

  const getPlaceDetailFromLatLng = useCallback(async (lat, lng) => {
    const apiKey = "tNjW3KnNdwrAsbelORJR7JirivVM2WgmVrgVTiK3";
    const url = `https://rsapi.goong.io/Geocode?latlng=${lat},${lng}&api_key=${apiKey}`;

    try {
      const response = await axios.get(url);
      if (response.data.results && response.data.results.length > 0) {
        const place = response.data.results[0];
        const regionName = formatString(place.compound.province || "");
        return {
          regionName,
          placeName: place.name,
          description: place?.formatted_address || "",
          lat: place.geometry.location.lat,
          lng: place.geometry.location.lng,
          place_id: place.place_id,
          compound: {
            ...place.compound,
            country: place.compound.country || "Việt Nam",
          },
        };
      }
      return null;
    } catch (error) {
      return null;
    }
  }, []);

  const detectLocation = useCallback(async () => {
    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        const placeDetail = await getPlaceDetailFromLatLng(latitude, longitude);

        if (placeDetail) {
          setProvinceDetect(placeDetail.compound.province);
          setCountryDetect(placeDetail.compound.country);
        }
      },
      (err) => {
        console.error("Lỗi khi lấy vị trí: ", err.message);
      },
    );
  }, [getPlaceDetailFromLatLng]);

  const getCountries = useCallback(async () => {
    setLoading(true);
    try {
      const res = await $axios.$get(
        `/hotel-tripi/hotel-content/countries`,
      );
      const _countries = moveToFirst(res.data.data.items, "id", 1);
      setCountries(_countries);
      setFilterCountries(_countries);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const getProvinces = useCallback(async (countryId) => {
    setLoadingLocation(true);
    try {
      const res = await $axios.$get(
        `/hotel-tripi/hotel-content/provinces?countryId=${countryId}`,
      );
      let _provinces = moveToFirst(res.data.data.items, "id", 11);
      _provinces = moveToFirst(res.data.data.items, "id", 33);
      setProvinces(_provinces);
      setFilterProvinces(res.data.data.items);
    } catch (error) {
    } finally {
      setLoadingLocation(false);
    }
  }, []);

  const processLocationDetect = useCallback(
    async (countryId) => {
      setLoading(true);
      try {
        const res = await $axios.$get(
          `/hotel-tripi/hotel-content/provinces?countryId=${countryId}`,
        );
        let _provinces = moveToFirst(res.data.data.items, "id", 11);
        _provinces = moveToFirst(res.data.data.items, "id", 33);
        setProvinces(_provinces);
        setFilterProvinces(res.data.data.items);
        const provinceName = _.get(
          _.find(res.data.data.items, (p) => p.name === provinceDetect),
          "name",
          "",
        );
        const countryCode = _.get(
          _.find(countries, (p) => p.id === countryId),
          "code",
          "",
        );
        if (provinceName && countryCode) {
          setFilter((prev) => ({
            ...prev,
            country: countryCode,
            address: provinceName,
          }));
          setChooseAddStep(2);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    },
    [countries, provinceDetect, setLoading],
  );

  useEffect(() => {
    detectLocation();
    getCountries();
  }, [detectLocation, getCountries]);

  // Khi đổi tỉnh thành thì reset KS đã chọn, từ khóa tìm kiếm KS, và danh sách KS đã cache
  useEffect(() => {
    setHotelSearch("");
    setHotelSelected(null);
    setSearchTermHotel("");
    setHotels([]);
    setDisplayHotels([]);
    setCurrentHotelPage(1);
    setCurrentAvailPage(1);
    setTotalHotelCount(0);
    setHasMoreHotels(false);
    setSearched(false);
  }, [filter.address]);

  useEffect(() => {
    if (countries.length > 0 && countryDetect && provinceDetect) {
      const countryId = _.get(
        _.find(countries, (c) => c.name === countryDetect),
        "id",
        "",
      );
      if (countryId) {
        processLocationDetect(countryId);
      }
    }
  }, [countries, countryDetect, provinceDetect, processLocationDetect]);

  useEffect(() => {
    if (chooseAddStep === 1) {
      setFilterCountries(
        _.filter(countries, (item) => {
          return _.includes(
            _.toLower(removeDiacritics(`${item.name} ${item.code}`)),
            _.toLower(removeDiacritics(searchTerm)),
          );
        }),
      );
    }
    if (chooseAddStep === 2) {
      setFilterProvinces(
        _.filter(provinces, (item) => {
          return _.includes(
            _.toLower(removeDiacritics(item.name)),
            _.toLower(removeDiacritics(searchTerm)),
          );
        }),
      );
    }
  }, [searchTerm, chooseAddStep, countries, provinces]);

  useEffect(() => {
    // Chưa chọn điểm đến → không gọi API lấy KS
    if (!filter.address) return;

    // Khi user gõ vào ô search → cho phép search dù đã chọn KS trước đó
    // (hotelSearch sẽ tự được thay thế khi user chọn KS khác)
    if (searchTermHotel && searchTermHotel.trim()) {
      const handler = setTimeout(async () => {
        const currentKeyword = searchTermHotel.trim();
        const serverResults = await searchHotelsByName(currentKeyword);
        if (!currentKeyword) return;
        setFilterHotel([
          { value: "", name: "Tất cả" },
          ..._.filter(serverResults, (h) => h.id),
        ]);
      }, 500);
      return () => clearTimeout(handler);
    }

    // searchTermHotel rỗng và chưa chọn KS → fetch list KS ban đầu
    if (!hotelSearch) {
      const handler = setTimeout(async () => {
        const serverResults = await searchHotelsByName("");
        setFilterHotel([
          { value: "", name: "Tất cả" },
          ..._.filter(serverResults, (h) => h.id),
        ]);
      }, 300);
      return () => clearTimeout(handler);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTermHotel, filter.address, filter.star, hotelSearch]);

  const onOpenChange = (type) => {
    setValueCalendar(form.getFieldValue(type) ?? new Date());
    setOpenCalendar(true);
    setTypeCalendar(type);
    if (type === "returnDate") {
      setMinDateCalendar(new Date(form.getFieldValue("departDate")));
    } else {
      setMinDateCalendar(new Date());
    }
  };

  const setValue = (value) => {
    form.setFieldValue(typeCalendar, dayjs(value));
    setValueCalendar(value);
    if (
      typeCalendar === "departDate" &&
      dayjs(value) >= form.getFieldValue("returnDate")
    ) {
      const newReturnDate = dayjs(value).add(1, "day");
      form.setFieldValue("returnDate", newReturnDate);
    }
    setOpenCalendar(false);
  };

  const fetchAndProcessAvailBatch = async (hotelList, startIdx, endIdx, body) => {
    const chunk = _.chunk(
      hotelList.slice(startIdx, endIdx + 1).map((h) => h.id),
      20,
    );
    const results = await Promise.all(
      chunk.map((ids) =>
        $axios
          .$post("/hotel-tripi/hotel-avail", { ...body, Hotels: ids })
          .catch(() => ({ data: { data: { hotels: [] } } })),
      ),
    );
    let allHotels = _.flatten(
      results.map((r) => _.get(r, "data.data.hotels", [])),
    );
    allHotels = allHotels.filter((h) => h.status !== "NoRoom");

    if (allHotels.length === 0) return [];

    const propertyIds = _.chunk(
      allHotels.map((h) => h.id),
      20,
    );
    const props = await Promise.all(
      propertyIds.map((ids) =>
        $axios
          .$post("/hotel-tripi/hotel-content/properties/content", {
            PropertyId: ids,
          })
          .catch(() => ({ data: { data: { items: [] } } })),
      ),
    );
    const hotelProperty = _.flatten(
      props.map((p) => _.get(p, "data.data.items", [])),
    );

    return allHotels
      .map((hotel) => {
        let property = hotelProperty.find((p) => p.Id === hotel.id);

        hotel.rooms = (hotel.rooms || [])
          .map((room) => {
            const validRates = (room.rates || []).filter(
              (r) => r.rateaftertaxtotal != null,
            );
            if (validRates.length === 0) return null;
            const roomInfo = property?.Rooms?.find(
              (r) => r.id.toString() === room.roomtypecode,
            );
            const minRate = _.minBy(validRates, "rateaftertaxtotal");
            const maxRate = _.maxBy(validRates, "rateaftertaxtotal");
            return {
              ...room,
              rates: validRates,
              minPrice: minRate?.rateaftertaxtotal || 0,
              maxPrice: maxRate?.rateaftertaxtotal || 0,
              ...roomInfo,
            };
          })
          .filter((room) => room !== null);

        if (hotel.rooms.length === 0) return null;

        if (property) {
          delete property.Id;
          hotel.minPrice = Math.min(...hotel.rooms.map((r) => r.minPrice));
          hotel.maxPrice = Math.max(...hotel.rooms.map((r) => r.maxPrice));
          return { ...hotel, ...property };
        }

        hotel.minPrice = Math.min(...hotel.rooms.map((r) => r.minPrice));
        hotel.maxPrice = Math.max(...hotel.rooms.map((r) => r.maxPrice));
        return hotel;
      })
      .filter((hotel) => hotel !== null);
  };

  const fetchMoreHotelBatch = async (page) => {
    const star = _.get(filter, "star", 6);
    const starParam = star === 6 ? "" : star;
    try {
      const res = await $axios.$get(
        `/hotel-tripi/getHotelMytours?name=&city=${filter.address}&startNumber=${starParam}&page=${page}&pageSize=50`,
      );
      const data = _.get(res, "data.data.data", []);
      return data;
    } catch (error) {
      console.log(`[fetchMoreHotelBatch] page=${page} ERROR:`, error);
      return [];
    }
  };

  const searchHotelsByName = async (name) => {
    setLoading(true);
    const star = _.get(filter, "star", 6);
    const starParam = star === 6 ? "" : star;
    try {
      const res = await $axios.$get(
        `/hotel-tripi/getHotelMytours?name=${encodeURIComponent(name)}&city=${filter.address}&startNumber=${starParam}&page=1&pageSize=50`,
      );
      const data = _.get(res, "data.data.data", []);
      const total = _.get(res, "data.data.totalrecordcount", 0);
      // Nếu không có từ khóa tìm kiếm (name rỗng) → cập nhật luôn hotels + filterHotel + total
      // để tránh gọi /getHotelMytours 2 lần
      if (!name || !name.trim()) {
        setHotels(data);
        setTotalHotelCount(total);
        setCurrentHotelPage(1);
        setHasMoreHotels(data.length < total);
      }
      return data;
    } catch (error) {
      console.log(`[searchHotelsByName] name="${name}" ERROR:`, error);
      return [];
    }
    finally {
      setLoading(false);
    }
  };

  const handleLoadMoreHotels = async (values) => {
    if (!values) return;
    const nextPage = currentHotelPage + 1;
    const moreHotels = await fetchMoreHotelBatch(nextPage);
    if (moreHotels.length === 0) {
      setHasMoreHotels(false);
      return;
    }

    setLoadingMore(true);
    const body = {
      StayCheckIn: dayjs(values.departDate).format("YYYY-MM-DD"),
      StayCheckOut: dayjs(values.returnDate).format("YYYY-MM-DD"),
      Nationality: filter.country,
      OccupanciesAdults: values.numAdults + values.numChilds,
      OccupanciesChildren: 0,
      LanguageCode: "vi",
      NumberOfUnits: values.numRooms,
      RealTimeSearch: true,
    };

    const newHotels = await fetchAndProcessAvailBatch(
      moreHotels,
      0,
      moreHotels.length - 1,
      body,
    );

    setHotels((prev) => [...prev, ...moreHotels]);
    setDisplayHotels((prev) => {
      const merged = [...prev, ...newHotels];
      const sortKey =
        sortBy && sortBy.startsWith("price") ? "maxPrice" : "starNumber";
      const sortDir = sortBy && sortBy.endsWith("desc") ? "desc" : "asc";
      return _.orderBy(merged, [sortKey], [sortDir]);
    });
    setCurrentHotelPage(nextPage);
    setHasMoreHotels(nextPage * hotelBatchSize < totalHotelCount);
    setLoadingMore(false);
  };

  const handleGetListHotelAvailable = async (values) => {
    if (values.numRooms > values.numAdults) {
      notification.warning({
        description: `Số phòng cần nhỏ hơn hoặc bằng số người lớn!`,
      });
      return;
    }
    if (!filter.address) {
      notification.warning({
        description: `Vui lòng chọn tỉnh thành cụ thể!`,
      });
      return;
    }

    setLoading(true);
    setDisplayHotels([]);
    setSearched(true);
    setCurrentAvailPage(1);
    setCurrentHotelPage(1);

    // const specialHotelIds = [50180, 50186, 29739, 50145];
    const specialHotelIds = [];

    const body = {
      StayCheckIn: dayjs(values.departDate).format("YYYY-MM-DD"),
      StayCheckOut: dayjs(values.returnDate).format("YYYY-MM-DD"),
      Nationality: filter.country,
      OccupanciesAdults: values.numAdults + values.numChilds,
      OccupanciesChildren: 0,
      LanguageCode: "vi",
      NumberOfUnits: values.numRooms,
      RealTimeSearch: true,
    };

    let workingHotels = [...hotels];
    let workingPage = currentHotelPage;
    let foundRooms = [];

    if (specialHotelIds.length > 0) {
      const specialHotelData = await fetchAndProcessAvailBatch(
        specialHotelIds.map((id) => ({ id })),
        0,
        specialHotelIds.length - 1,
        body,
      );
      const validSpecialHotels = specialHotelData.filter(
        (h) => h.status !== "NoRoom",
      );
      foundRooms = [...foundRooms, ...validSpecialHotels];
    }

    // Khi đã chọn KS cụ thể (hotelSearch != "") → chỉ check 1 KS đó, không auto-fetch thêm page
    if (hotelSearch) {
      const selectedHotel =
        hotels.find((h) => h.id === hotelSearch) || { id: hotelSearch };
      const availResult = await fetchAndProcessAvailBatch(
        [selectedHotel],
        0,
        0,
        body,
      );
      foundRooms = availResult;
      setHotels([selectedHotel].filter(Boolean));
      setCurrentHotelPage(1);
      setCurrentAvailPage(1);
      setHasMoreHotels(false);
    } else {
      foundRooms = await fetchAndProcessAvailBatch(
        workingHotels,
        0,
        workingHotels.length - 1,
        body,
      );
      let page = 1;
      while (
        foundRooms.length === 0 &&
        workingPage * hotelBatchSize < totalHotelCount
      ) {
        const nextPage = workingPage + 1;
        const moreHotels = await fetchMoreHotelBatch(nextPage);
        if (moreHotels.length === 0) break;
        workingHotels = [...workingHotels, ...moreHotels];
        workingPage = nextPage;
        const newFound = await fetchAndProcessAvailBatch(
          moreHotels,
          0,
          moreHotels.length - 1,
          body,
        );
        foundRooms = newFound;
        page++;
      }
      setHotels(workingHotels);
      setCurrentHotelPage(workingPage);
      setCurrentAvailPage(workingPage);
      setHasMoreHotels(workingPage * hotelBatchSize < totalHotelCount);
    }

    setDisplayHotels(_.orderBy(foundRooms, ["maxPrice"], "asc"));
    setSortBy("price:asc");
    setLoading(false);
  };

  const handleSelectAdd = (value, type = "country" | "province" | "hotel") => {
    if (type === "hotel") {
      setSearched(false);
      setHotelSearch(value);
      setOpenDrawerChooseHotel(false);
      return;
    }
    if (type === "country") {
      setChooseAddStep(2);
      getProvinces(value);
      setFilter((prev) => ({
        ...prev,
        country: _.find(countries, (c) => c.id === value).code,
        address: "",
      }));
    } else {
      setOpenDrawerChooseAdd(false);
      setFilter((prev) => ({
        ...prev,
        address: _.get(
          _.find(provinces, (c) => c.id === value),
          "name",
        ),
      }));
      setHotelSearch("");
      setHotelSelected(null);
    }
    setSearchTerm("");
  };

  const handleCloseChooseHotelDrawer = async () => {
    setSearchTermHotel("");
    const serverResults = await searchHotelsByName("");
    setFilterHotel([
      { value: "", name: "Tất cả" },
      ..._.filter(serverResults, (h) => h.id),
    ]);
  };

  const handleSearchHotelInputChange = async (value) => {
    setSearchTermHotel(value);
    if (value === "") {
      const serverResults = await searchHotelsByName("");
      setFilterHotel([
        { value: "", name: "Tất cả" },
        ..._.filter(serverResults, (h) => h.id),
      ]);
    }
  };

  const handleSortPriceHotel = () => {
    const _displayHotels = _.cloneDeep(displayHotels);
    if (sortBy === "price:desc") {
      setDisplayHotels(_.orderBy(_displayHotels, ["maxPrice"], "asc"));
      setSortBy("price:asc");
    } else {
      setDisplayHotels(_.orderBy(_displayHotels, ["maxPrice"], "desc"));
      setSortBy("price:desc");
    }
  };

  const handleSortStarHotel = () => {
    const _displayHotels = _.cloneDeep(displayHotels);
    if (sortBy === "star:desc") {
      setDisplayHotels(_.orderBy(_displayHotels, ["starnumber"], "asc"));
      setSortBy("star:asc");
    } else {
      setDisplayHotels(_.orderBy(_displayHotels, ["starnumber"], "desc"));
      setSortBy("star:desc");
    }
  };

  const setFormValueAndSearch = (addressName) => {
    setFilter((prev) => ({
      ...prev,
      address: addressName,
      country: "VN",
    }));
    window.scrollTo({ top: 400, behavior: "smooth" });
  };

  return {
    form,
    countries,
    filterCountries,
    chooseAddStep,
    setChooseAddStep,
    hotels,
    openChooseHotel,
    setOpenChooseHotel,
    hotelSelected,
    setHotelSelected,
    provinces,
    filterProvinces,
    searched,
    setSearched,
    addPrice,
    openDrawerChooseAdd,
    setOpenDrawerChooseAdd,
    openDrawerChooseHotel,
    setOpenDrawerChooseHotel,
    searchTerm,
    setSearchTerm,
    searchTermHotel,
    setSearchTermHotel,
    currentPage,
    setCurrentPage,
    pageSize,
    loadingLocation,
    displayHotels,
    setDisplayHotels,
    valueCalendar,
    openCalendar,
    setOpenCalendar,
    typeCalendar,
    minDateCalendar,
    sortBy,
    filterHotel,
    filter,
    setFilter,
    hotelSearch,
    setHotelSearch,
    totalHotelCount,
    currentHotelPage,
    hotelBatchSize,
    hasMoreHotels,
    loadingMore,
    currentAvailPage,
    handleLoadMoreHotels,
    onOpenChange,
    setValue,
    handleGetListHotelAvailable,
    getProvinces,
    handleSelectAdd,
    handleSortPriceHotel,
    handleSortStarHotel,
    handleCloseChooseHotelDrawer,
    handleSearchHotelInputChange,
    setFormValueAndSearch,
  };
};
